// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.user_header {
  padding: 5px 25px;
  display: flex;
  justify-content: space-between;
  background: #ffffff 0% 0% no-repeat padding-box;
  place-items: center;
}
.user_header .user_img {
  display: flex;
  place-items: center;
}
.user_header .user_imgs {
  height: 69px;
  width: 69px;
  margin-right: 20px;
}
.user_img p {
  margin: 0;
}
.user_header .user_imgs img {
  width: 100%;
  height: auto;
}
.selected_Button_bg {
  background-color: #108757;
  color: #fff;
}
.user_header button img,
button.accueil img {
  margin: 0 15px;
}
.user_header button,
button.accueil {
  display: flex;
  place-items: center;
  min-width: 129px;
  border: 1px solid #108757;
  color: #108757;
  margin-left: 20px;
  background: #1087571a 0% 0% no-repeat padding-box;
  height: 37px;
}
.notifiaction_bar {
  display: flex;
}

.addSaved .MuiPaper-root.MuiPaper-elevation {
  color: #000000e6;
  border: 1px solid #bcebdc;
  background-color: #bcebdc;
  font-size: 14px;
  display: flex;
  padding: 0 26px;
  place-items: center;
  height: 54px;
  margin-left: auto;
}
.addSaved img {
  margin-right: 5px;
}
.addSaved {
  display: flex;
  justify-content: space-between;
  min-width: 250px;
}
.addSaved svg {
  margin-left: 5px;
  font-size: 14px;
}
.fremimg {
  text-align: center;
  margin: 0 auto;
  padding: 30px 0 10px;
}
.ResumeTableSection {
  max-width: 750px;
  margin: 0 auto;
}
.fremimg img {
  margin: 0 auto;
}
.fremimg h3 {
  padding: 20px;
  font-size: 24px;
  color: #373737;
}
.information_form {
  max-width: 600px;
  margin: 0 auto !important;
  border: 1px solid #ffbe00;
  background-color: #ffbe001a;
}
p {
  font-size: 14px;
  color: #373737;
}
.questionPage {
  max-width: 750px;
  margin: 20px auto 10px;
}
.notifiaction_status {
  position: relative;
  margin-right: 15px;
}
.notifiaction_status span {
  position: absolute;
  background-color: red;
  border-radius: 50%;
  top: -8px;
  text-align: center;
  right: -8px;
  line-height: 21px;
  width: 20px;
  height: 21px;
  font-size: 11px;
  color: #fff;
}
.user_content {
  text-align: center;
  width: 230px;
  height: 249px;
}
.user_content p {
  position: relative;
  padding: 16px 15px;
  margin: 0 auto;
  max-width: 196px;
  color: #108757;
}
.user_content:hover {
  background: #1087571a 0% 0% no-repeat padding-box;
}
.user_content {
  cursor: pointer;
  background: #fafafa 0% 0% no-repeat padding-box;
}
.user_content_img {
  height: 150px;
  padding: 20px;
}
.user_content img {
  width: 100%;
  height: auto;
}
.content_disponibles h4 {
  padding-bottom: 20px;
  color: #373737;
  font-weight: bold;
  font-size: 20px;
  text-align: center;
}

.user_content p span {
  position: absolute;
  top: 15px;
  right: 0;
}
.user_content p span svg {
  font-size: 15px;
}
/* ********************* */
.stepFormfields {
  padding: 0 15px;
  margin-top: 10px;
}
.butnaccueil {
  flex-wrap: wrap;
  display: flex;
  place-items: center;
}
.butnaccueil .accueil svg {
  fill: #108757;
  margin-right: 10px;
  margin-left: 10px;
}
.butnaccueil p {
  font-size: 14px;
  color: #373737;
  font-weight: 600;
  margin: 0 20px;
}
.addSaved .MuiPaper-root.MuiPaper-elevation {
  color: #000000e6;
  border: 1px solid #bcebdc;
  background-color: #bcebdc;
  font-size: 14px;
  display: flex;
  padding: 0 26px;
  place-items: center;
  height: 54px;
  margin-left: auto;
}
.addSaved img {
  margin-right: 5px;
}
.addSaved {
  display: flex;
  justify-content: space-between;
  min-width: 250px;
}
.addSaved svg {
  margin-left: 5px;
  font-size: 14px;
}
.fremimg {
  text-align: center;
  margin: 0 auto;
  padding: 30px 0 10px;
}
.ResumeTableSection {
  max-width: 750px;
  margin: 0 auto;
}
.fremimg img {
  margin: 0 auto;
}
.fremimg h3 {
  padding: 20px;
  font-size: 24px;
  color: #373737;
}
.information_form {
  max-width: 600px;
  margin: 0 auto !important;
  border: 1px solid #ffbe00;
  background-color: #ffbe001a;
}
p {
  font-size: 14px;
  color: #373737;
}
.questionPage {
  max-width: 750px;
  margin: 20px auto 10px;
}
.questionPage Accordion svg {
  display: none;
}
/* .MuiAccordionSummary-gutters [aria-expanded="true"]{
    background-color: red;
} */
.Mui-expanded.MuiAccordionSummary-gutters {
  background: #108757 !important;
  max-height: 50px !important;
  min-height: 50px !important;
}
.questionPage .MuiAccordionSummary-gutters p {
  position: relative;
  font-weight: 600;
  color: #373737;
  padding-left: 35px;
}
.questionPage .MuiAccordionSummary-gutters svg {
  display: none;
}
.Mui-expanded.MuiAccordionSummary-gutters p {
  color: #fff !important;
}
.MuiAccordionSummary-gutters p span {
  width: 100%;
  display: block;
  font-size: 10px !important;
}
.MuiPaper-elevation1.MuiAccordion-root {
  margin: 10px 0;
}
accordion .MuiFormControl-root label.MuiFormLabel-root {
  padding: 10px 0;
}
.user_header button img,
button.accueil img {
  margin: 0 15px;
}
.radiobtn_custom {
  /* width: 15px !important; */
  position: absolute;
  left: 0;
  top: 10px;
  /* height: 15px; */
  /* border-radius: 50%; */
  /* border: 1px solid #eee; */
  /* background: #fff; */
}
.questionPage
  .Mui-expanded.MuiAccordionSummary-gutters
  .radiobtn_custom
  svg
  #check {
  fill: #108757;
}
.questionPage .Mui-expanded.MuiAccordionSummary-gutters .radiobtn_custom svg g {
  fill: #fff !important;
}
.questionPage .radiobtn_custom svg {
  display: block;
}
.questionPage button {
  border: 1px solid #108757;
  color: #108757;
  /* height: 60px; */
  padding: 12px 30px;
}
/* ****************** */
.cahiersheet-optionsheet .enteres-option {
  margin-bottom: 30px;
  color: #373737;
  font-size: 16px;
  font-weight: 600;
}
.transection-option .form-label {
  color: #373737;
  font-size: 16px;
  padding: 20px 24px;
  border-bottom: 1px solid #ddd;
}
.transection-option .MuiGrid-root {
  position: relative;
}

.transection-option .ant-space.ant-space-vertical {
  position: relative;
}
.transection-option {
  border: 1px solid #ddd !important;
  border-radius: 5px;
  width: 100%;
  margin-bottom: 30px !important;
}
.transection-option .MuiFormGroup-root {
  padding: 0 40px;
}
/* .questionPage .MuiTextField-root .Mui-error.MuiInputBase-formControl:hover{
 border: 1px solid red;
} */
.questionPage
  .Mui-error.MuiInputBase-formControl:hover
  .MuiOutlinedInput-notchedOutline {
  border-color: #d32f2f;
}
/* .MuiInputBase-colorPrimary.Mui-error.MuiInputBase-formControl:hover .MuiOutlinedInput-notchedOutline{
  border-color: #d32f2f;
} */
/* ***************** */
.btntag {
  border: 1px solid #108757;
  width: 130px;
  height: 37px;
  color: #108757;
  display: flex !important;
  place-items: center;
  padding: 1px 15px;
}
.btntag svg {
  fill: #ededed !important;
}
.resumeTabels th {
  height: 130px;
  background-color: #ededed;
  width: 220px;
  max-width: 220px;
  border: 1px solid #fafafa !important;
}
.resumeTabels th,
.resumeTabels td {
  border: 1px solid #ededed;
  text-transform: capitalize;
  padding: 0 15px;
  min-width: 200px;
  text-align: left;
  color: #373737;
  font-weight: 600;
}
.submitButton {
  color: #fff !important;
  background: #238957;
  border: none;
}
.firstcreatCreer {
  margin-top: 30px;
  border: 1px solid #ededed;
}
.optionforans {
  padding: 33px 40px 31px !important;
}
.datepicbyyear {
  place-items: center;
  cursor: pointer;
  justify-content: center;
  display: flex;
  border: 1px solid #108757;
  width: 200px;
  height: 30px;
  margin-left: 90px;
}
.claenderweekss h2 svg {
  font-size: 14px;
}
.claenderweekss h2 {
  padding: 5px 10px;
}
.creatbtn-redirect {
  margin-left: auto;
}
.feremtabn .creatbtn-redirect button {
  max-height: 50px !important;
}

.stepform-fiche {
  height: 100% !important;
}
.datepicbyyear input {
  outline: none;
}
.conditionshowCreat {
  width: 536%;
  text-align: center;
}
.feremtabn {
  display: flex;
  flex-wrap: wrap;
}
.feremtabn .Mui-selected {
  background: #108757;
  min-height: 25px !important;
  max-height: 30px !important;
  color: #ffff !important;
}
.nav.nav-pills.pull-right .tabbtn {
  display: flex;
  min-width: 140px;
  padding: 0 10px;
  height: 30px !important;
  justify-content: center;
  place-items: center;
}
.nav.nav-pills.pull-right {
  display: flex;
  margin-bottom: 0;
  margin-left: 20px;
}
.feremtabn .nav.nav-pills.pull-right .tabbtn {
  margin: 2px 10px;
  text-transform: capitalize;
  min-height: 37px !important;
}

.nav.nav-pills.pull-right .tabbtn,
.feremtabn button {
  color: #108757;
  min-height: 25px !important;
  max-height: 30px !important;
  border: 1px solid #108757;
}
.feremtabn span.MuiTabs-indicator.css-54v6xy-MuiTabs-indicator,
.datepicbyyear fieldset {
  display: none;
}
.conditionshowCreat p {
  font-size: 16px;
  padding-top: 5px;
}
.datepicbyyear .MuiSelect-select {
  padding-right: 0 !important;
}
.datepicbyyear .MuiOutlinedInput-root {
  height: 28px;
  border: none;
}
.datepicbyyear .MuiOutlinedInput-root:hover {
  border: none;
}
.datepicbyyear .MuiOutlinedInput-root svg {
  display: none;
}
.datepicbyyear label {
  line-height: 1;
  top: -9px;
}
.datepicbyyear .css-1xyznfm-MuiFormLabel-root-MuiInputLabel-root {
  display: none;
}
.whiteColor {
  color: #fff;
}

.questionPage h2 {
  padding-bottom: 20px;
  padding-left: 40px;
}
.questionPage h1 {
  margin-top: 40px;
  font-size: 34px;
  color: #979797;
  font-weight: 600;
  text-align: center;
}
.weektextday p {
  margin: 0;
}
.weektextday {
  position: relative;
  color: #979797;
  font-size: 14px;
  text-align: center;
  border: 1px solid #108757;
  width: 102px;
  height: 79px;
  vertical-align: middle;
  display: table-cell;
  /* margin: 0 auto; */
}
.calenderWeek {
  padding: 15px 45px;
  border: 1px solid #ededed;
  margin-bottom: 20px;
}
.questionPage label#demo-radio-buttons-group-label {
  padding: 15px 0 !important;
}
.ant-steps-item-finish .ant-steps-item-icon {
  background-color: #108757 !important;
  /* top:-3.5px !important; */
}
.ant-steps-item-finish .ant-steps-icon {
  top: -3.5px !important;
}
.ant-steps-item-finish .ant-steps-item-icon svg {
  fill: #fff;
}
/* MuiButtonBase-root MuiRadio-root MuiRadio-colorPrimary PrivateSwitchBase-root MuiRadio-root MuiRadio-colorPrimary MuiRadio-root MuiRadio-colorPrimary css-v39bad */
.claenderweekss .weektextday .MuiFormControlLabel-root .MuiRadio-root {
  left: 0 !important;
  position: absolute !important;
  width: 100%;
  height: 100%;
  /* opacity: 0; */
  top: 0;
}
/* .css-1uef0s5-MuiButtonBase-root-MuiRadio-root.Mui-checked .weektextday .css-1uef0s5-MuiButtonBase-root-MuiRadio-root:after{
    width: 100%;
    left: 0 !important;
    position: absolute !important;
    width: 100%;
    height: 100%;
    content: "";
    border: 10px solid red;
    top: 0;

} */
.claenderweekss
  span.MuiButtonBase-root.MuiRadio-root.MuiRadio-colorPrimary.PrivateSwitchBase-root.MuiRadio-root.MuiRadio-colorPrimary.Mui-checked:after {
  left: 0;
  position: absolute !important;
  width: 100%;
  z-index: -1;
  height: 100%;
  background-color: #108757;
  content: "";
  border: 5px solid #108757;
  top: 0;
  opacity: 1;
}
.claenderweekss
  span.MuiButtonBase-root.MuiRadio-root.MuiRadio-colorPrimary.PrivateSwitchBase-root.MuiRadio-root.MuiRadio-colorPrimary.Mui-checked.MuiRadio-root.MuiRadio-colorPrimary.css-1uef0s5-MuiButtonBase-root-MuiRadio-root
  ~ p {
  color: #fff !important;
}
.claenderweekss label {
  margin-left: 16px !important;
  height: 100%;
}
.questionPage .MuiPaper-elevation {
  box-shadow: none;
  border: 1px solid #cacaca;
}
.weektextday .css-hyxlzm {
  opacity: 0;
}
/* ::::::::::::::::Radio:::::::: */
.cahiersheet-optionsheet .MuiFormControl-root.MuiTextField-root {
  max-width: 800px;
  width: 100%;
  margin-bottom: 30px;
}
.cahiersheet-optionsheet span {
  font-size: 16px;
  color: rgb(55, 55, 55);
  font-weight: 600;
  /* color: #373737; */
}
.cahiersheet-optionsheet .ant-input-number-group-wrapper,
.cahiersheet-optionsheet .ant-space.ant-space-vertical {
  max-width: 800px;
  width: 100%;
  /* margin-bottom: 15px; */
}

.cahiersheet-optionsheet .ant-input-number-group-wrapper {
  border: 1px solid #cacaca;
}
.cahiersheet-optionsheet
  .MuiInputBase-formControl:hover
  .MuiOutlinedInput-notchedOutline {
  border-color: #238957;
}

.cahiersheet-optionsheet .ant-input-number-group-wrapper input {
  height: 55px;
}
.questionPage .transection-option .cahier-label {
  font-size: 16px;
  color: #373737;
  font-weight: 600;
  letter-spacing: 0.26px;
  opacity: 1;
  padding: 20px 0px;
}
.cahiersheet-optionsheet .outlined-basic {
  font: 16px;
  letter-spacing: 0.26px;
  color: #979797;
  opacity: 1;
}
/* .cahiersheet-optionsheet .ant-space-item .ant-select  span.ant-select-arrow{
    display: none !important;
} */
.cahiersheet-optionsheet .ant-space-item .MuiInputBase-formControl {
  padding: 0 !important;
}
.cahiersheet-optionsheet .MuiInputBase-colorPrimary.MuiInputBase-formControl {
  height: 65px;
}

/* :::::::::::::::::::::::step:::::::::::::: */
.MuiStepLabel-vertical {
  cursor: pointer !important;
}

.questionPage.transection-option .MuiFormGroup-root {
  padding-top: 10px !important;
}
.claenderweekss .react-datepicker__day-names,
.claenderweekss .react-datepicker__month {
  display: none;
}
.claenderweekss .react-datepicker {
  border: none;
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding-bottom: 30px !important;
  padding: 0 65px;
  background: #fafafa;
}
.claenderweekss .react-datepicker__navigation {
  border: none;
  outline: none;
}
.claenderweekss .react-datepicker__header {
  background: #fafafa;
  /* border: none; */
}
.claenderweekss
  span.react-datepicker__navigation-icon.react-datepicker__navigation-icon--previous {
  border-color: #373737;
  border-style: solid;
  border-width: 3px 3px 0 0;
  content: "";
  display: block;
  height: 9px;
  position: absolute;
  top: 6px;
  width: 9px;
  transform: rotate(225deg);
  right: -7px;
  left: 2px;
}
/* .claenderweekss .react-datepicker__navigation-icon--previous:before {
    transform: rotate(225deg);
    right: -7px;
} */

.claenderweekss
  span.react-datepicker__navigation-icon.react-datepicker__navigation-icon--next {
  transform: rotate(45deg);
  border-color: #373737;
  right: 5;
  border-style: solid;
  border-width: 3px 3px 0 0;
  content: "";
  display: block;
  height: 9px;
  position: absolute;
  top: 6px;
  width: 9px;
}
.seconddatetabel .MuiFormControl-root.css-1nrlq1o-MuiFormControl-root {
  max-width: 223px;
  margin-left: auto;
  display: flex;
}
.Appbatabbtn .feremtabn .MuiTab-textColorPrimary.Mui-selected {
  background-color: #108757;
  color: #fff;
  fill: #fff;
}
.Appbatabbtn button {
  max-height: 43px !important;
}
.Appbatabbtn .feremtabn .MuiTab-textColorPrimary.Mui-selected svg {
  fill: #fff;
}
.Appbatabbtn .feremtabn svg {
  fill: #108757;
  margin-right: 10px;
}
.claenderweekss .react-datepicker__year-read-view {
  opacity: 0;
  visibility: visible;
}
.claenderweekss .react-datepicker__year-dropdown {
  min-width: 92px;
}
.claenderweekss
  .react-datepicker__header__dropdown.react-datepicker__header__dropdown--scroll {
  position: absolute;
  top: 8px;
  width: 100%;
  z-index: 9;
}
.claenderweekss
  .react-datepicker__year-dropdown-container.react-datepicker__year-dropdown-container--scroll {
  width: 100%;
}
.claenderweekss .react-datepicker__header {
  position: relative;
}
/* .customyeardropdown button{
    border: 0.45rem solid transparent;
    z-index: 1;
    top:5px;
    height: 10px;
    width: 10px;
} */
.customyeardropdown
  .react-datepicker__navigation.react-datepicker__navigation--previous,
.customyeardropdown
  .react-datepicker__navigation.react-datepicker__navigation--next {
  transform: rotate(45deg);
  border-color: #373737;
  right: 5;
  border-style: solid;
  border-width: 3px 3px 0 0;
  content: "";
  display: block;
  min-height: 9px !important;
  position: absolute;
  top: 12px;
  width: 9px;
}
.customyeardropdown
  .react-datepicker__navigation.react-datepicker__navigation--previous {
  transform: rotate(225deg);
}
.datepicbyyear input[type="text"] {
  max-width: 150px;
  cursor: pointer;
}

.accordionRadio {
  display: flex !important;
  flex-direction: column !important;
}
.ResumeTableSection td {
  color: #373737;
  font-size: 16px;
  font-weight: 600;
}
.ResumeTableSection td h1 {
  color: #373737;
  padding-top: 20px;
  padding-bottom: 15px;
  font-size: 16px;
}
.resumeTabels td h4,
.ResumeTableSection td h4 {
  color: #979797;
  margin: 0;
  font-size: 14px;
}
.resumeTabels td p,
.ResumeTableSection td p {
  color: #373737;
  font-size: 14px;
}
.resumeTabels .tabel-edit-section {
  display: flex;
  place-items: center;
  height: 130px;
  justify-content: space-between;
}
.resumeTabels .editIcon-on-tabel svg {
  margin: 0 auto;
}
.resumeTabels .editIcon-on-tabel svg,
.resumeTabels .editIcon-on-tabel {
  color: #cacaca;
  cursor: pointer;
  fill: #cacaca;
}
.resumeTabels .editIcon-on-tabel:hover svg {
  fill: #108757;
}
.resumeTabels .editIcon-on-tabel:hover {
  color: #108757;
}
.cfa-text p {
  position: inherit !important;
}
.cfa-text {
  position: absolute;
  top: 0;
  right: 2px;
  height: 64px;
  z-index: -1;
}
.questionPage .ant-space-item input.MuiInputBase-input {
  padding-right: 70px;
}
/* ******************** repoprt css***************** */

.stockReportSection {
  /* min-width: 1200px; */
  max-width: 1200px;
  width: 100%;
  margin: 0px auto 10px;
}
.stockReportSection .card {
  padding: 15px 25px 15px 15px;
  margin: 0px 0 20px;
}

.stockReportSection .items-dtails h4 {
  font-size: 20px;
  color: #979797 !important;
  font-weight: normal !important;
}
.items-dtails:nth-child(1) {
  border-bottom: 1px solid #ededed;
  width: 80%;
}
.report-img h2 {
  font-size: 20px;
}
.stockReportSection .items-dtails p {
  font-size: 14px;
  max-width: 216px;
  margin-top: 10px;
  margin-left: 10px;
}
.items-dtails-quantity {
  min-width: 200px;
}
.stockReportSection .items-dtails h3 {
  font-size: 30px;
  color: #373737 !important;
  margin-bottom: 0;
  font-weight: normal !important;
}
.stockReportSection .items-dtails {
  padding: 10px 0px;
}
p,
h1,
h3,
h4,
h5,
h6 {
  color: #373737;
}
.stockReportSection .report-img svg {
  margin: 0 auto;
}
.stockReportSection .report-img {
  text-align: center;
}
.stockReportSection .MuiGrid-container {
  place-items: center;
}
.button-on-report {
  color: #108757;
  border: 1px solid #108757;
  width: 243px;
  width: 100%;
  height: 60px;
}
.items-dtails {
  display: flex;
}
.feremtabn .MuiTabs-scroller .MuiTabs-flexContainer {
  max-width: 472px;
  overflow: auto;
  padding-bottom: 3px;
}
::-webkit-scrollbar {
  width: 5px;
  height: 5px;
  background: #ddd !important;
}

::-webkit-scrollbar-thumb {
  background: #108757 !important;
}

/* ************************report details css****************** */
/* .ant-tabs-tab.ant-tabs-tab-active{
    
} */
.ant-tabs-tab.ant-tabs-tab-active {
  background-color: #108757 !important;
  color: #fff;
}
.ant-tabs-tab svg {
  margin: 0 auto;
}
.ant-tabs-tab {
  justify-content: center;
  width: 213px;
  height: 152px;
}
.ant-tabs-tab.ant-tabs-tab-active h1 {
  color: #fff !important;
}
.stockReportSection h4.pt-4 {
  font-size: 18px;
}
.nav.nav-pills.pull-right .active {
  background-color: #108757;
  color: #fff;
}
.nav.nav-pills.pull-right .active svg {
  fill: #fff;
}
@media screen and (max-width: 467px) {
  .claenderweekss .react-datepicker {
    padding: 0 30px;
  }
}

@media screen and (max-width: 767px) {
  .information_form {
    max-width: 520px;
  }

  .weektextday {
    width: 90px;
  }
  .claenderweekss label {
    margin-left: 8px !important;
  }
}

@media screen and (max-width: 990px) {
  .user_header .user_img {
    display: initial;
  }
  .nav.nav-pills.pull-right {
    margin-top: 15px;
  }
  .datepicbyyear {
    margin-left: 10px;
  }
  .creatbtn-redirect {
    margin: 0 auto;
  }
}
/* ************ velidation *********** */
.errorText,
p.Mui-error,
.MuiFormHelperText-root {
  color: red !important;
  font-size: 14px;
  font-weight: 500;
}

.cahiersheet-optionsheet .MuiBox-root .transection-option,
.cahiersheet-optionsheet .MuiFormControl-fullWidth.transection-option {
  border: 0px solid !important;
  position: relative;
}
.transection-option .MuiBox-root p,
.transection-option .ant-space.ant-space-vertical p {
  position: absolute;
  color: red !important;
  bottom: -22px;
}
`, "",{"version":3,"sources":["webpack://./src/components/Layout/style.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,+CAA+C;EAC/C,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,SAAS;AACX;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,yBAAyB;EACzB,WAAW;AACb;AACA;;EAEE,cAAc;AAChB;AACA;;EAEE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,iDAAiD;EACjD,YAAY;AACd;AACA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,yBAAyB;EACzB,eAAe;EACf,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,oBAAoB;AACtB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;EACb,eAAe;EACf,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,yBAAyB;EACzB,2BAA2B;AAC7B;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;EAClB,SAAS;EACT,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,iDAAiD;AACnD;AACA;EACE,eAAe;EACf,+CAA+C;AACjD;AACA;EACE,aAAa;EACb,aAAa;AACf;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,oBAAoB;EACpB,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;AACV;AACA;EACE,eAAe;AACjB;AACA,0BAA0B;AAC1B;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,yBAAyB;EACzB,eAAe;EACf,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,oBAAoB;AACtB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;EACb,eAAe;EACf,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,yBAAyB;EACzB,2BAA2B;AAC7B;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,sBAAsB;AACxB;AACA;EACE,aAAa;AACf;AACA;;GAEG;AACH;EACE,8BAA8B;EAC9B,2BAA2B;EAC3B,2BAA2B;AAC7B;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,aAAa;AACf;AACA;EACE,sBAAsB;AACxB;AACA;EACE,WAAW;EACX,cAAc;EACd,0BAA0B;AAC5B;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;AACjB;AACA;;EAEE,cAAc;AAChB;AACA;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,OAAO;EACP,SAAS;EACT,kBAAkB;EAClB,wBAAwB;EACxB,4BAA4B;EAC5B,sBAAsB;AACxB;AACA;;;;;EAKE,aAAa;AACf;AACA;EACE,qBAAqB;AACvB;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACpB;AACA,uBAAuB;AACvB;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,6BAA6B;AAC/B;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,iCAAiC;EACjC,kBAAkB;EAClB,WAAW;EACX,8BAA8B;AAChC;AACA;EACE,eAAe;AACjB;AACA;;GAEG;AACH;;;EAGE,qBAAqB;AACvB;AACA;;GAEG;AACH,sBAAsB;AACtB;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,cAAc;EACd,wBAAwB;EACxB,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;EAChB,oCAAoC;AACtC;AACA;;EAEE,yBAAyB;EACzB,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;EACE,kCAAkC;AACpC;AACA;EACE,mBAAmB;EACnB,eAAe;EACf,uBAAuB;EACvB,aAAa;EACb,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,eAAe;AACjB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;AACzB;AACA;EACE,aAAa;AACf;AACA;EACE,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,2BAA2B;EAC3B,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,uBAAuB;EACvB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;;EAEE,cAAc;EACd,2BAA2B;EAC3B,2BAA2B;EAC3B,yBAAyB;AAC3B;AACA;;EAEE,aAAa;AACf;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,YAAY;EACZ,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,aAAa;AACf;AACA;EACE,cAAc;EACd,SAAS;AACX;AACA;EACE,aAAa;AACf;AACA;EACE,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,oCAAoC;EACpC,2BAA2B;AAC7B;AACA;EACE,sBAAsB;AACxB;AACA;EACE,UAAU;AACZ;AACA,qKAAqK;AACrK;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,MAAM;AACR;AACA;;;;;;;;;;GAUG;AACH;;EAGE,OAAO;EACP,6BAA6B;EAC7B,WAAW;EACX,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,WAAW;EACX,yBAAyB;EACzB,MAAM;EACN,UAAU;AACZ;AACA;;;EAGE,sBAAsB;AACxB;AACA;EACE,4BAA4B;EAC5B,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;EACE,UAAU;AACZ;AACA,kCAAkC;AAClC;EACE,gBAAgB;EAChB,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,sBAAsB;EACtB,gBAAgB;EAChB,oBAAoB;AACtB;AACA;;EAEE,gBAAgB;EAChB,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;AACA;;;EAGE,qBAAqB;AACvB;;AAEA;EACE,YAAY;AACd;AACA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,sBAAsB;EACtB,UAAU;EACV,iBAAiB;AACnB;AACA;EACE,UAAU;EACV,sBAAsB;EACtB,cAAc;EACd,UAAU;AACZ;AACA;;GAEG;AACH;EACE,qBAAqB;AACvB;AACA;EACE,YAAY;AACd;;AAEA,8CAA8C;AAC9C;EACE,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;AAC9B;AACA;;EAEE,aAAa;AACf;AACA;EACE,YAAY;EACZ,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,+BAA+B;EAC/B,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,aAAa;AACf;AACA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;AACA;;EAEE,qBAAqB;EACrB,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;EACX,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,yBAAyB;EACzB,WAAW;EACX,SAAS;AACX;AACA;;;GAGG;;AAEH;;EAEE,wBAAwB;EACxB,qBAAqB;EACrB,QAAQ;EACR,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;EACX,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,UAAU;AACZ;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;AACf;AACA;EACE,yBAAyB;EACzB,WAAW;EACX,UAAU;AACZ;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,UAAU;AACZ;AACA;EACE,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,UAAU;EACV,mBAAmB;AACrB;AACA;EACE,eAAe;AACjB;AACA;;EAEE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,UAAU;AACZ;AACA;;EAEE,WAAW;AACb;AACA;EACE,kBAAkB;AACpB;AACA;;;;;;GAMG;AACH;;;;EAIE,wBAAwB;EACxB,qBAAqB;EACrB,QAAQ;EACR,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;EACX,cAAc;EACd,0BAA0B;EAC1B,kBAAkB;EAClB,SAAS;EACT,UAAU;AACZ;AACA;;EAEE,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,wBAAwB;EACxB,iCAAiC;AACnC;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;AACjB;AACA;;EAEE,cAAc;EACd,SAAS;EACT,eAAe;AACjB;AACA;;EAEE,cAAc;EACd,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,8BAA8B;AAChC;AACA;EACE,cAAc;AAChB;AACA;;EAEE,cAAc;EACd,eAAe;EACf,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,cAAc;AAChB;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,UAAU;EACV,YAAY;EACZ,WAAW;AACb;AACA;EACE,mBAAmB;AACrB;AACA,sDAAsD;;AAEtD;EACE,uBAAuB;EACvB,iBAAiB;EACjB,WAAW;EACX,qBAAqB;AACvB;AACA;EACE,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,8BAA8B;AAChC;AACA;EACE,gCAAgC;EAChC,UAAU;AACZ;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,8BAA8B;AAChC;AACA;EACE,iBAAiB;AACnB;AACA;;;;;;EAME,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,yBAAyB;EACzB,YAAY;EACZ,WAAW;EACX,YAAY;AACd;AACA;EACE,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,UAAU;EACV,WAAW;EACX,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;AAChC;;AAEA,iEAAiE;AACjE;;GAEG;AACH;EACE,oCAAoC;EACpC,WAAW;AACb;AACA;EACE,cAAc;AAChB;AACA;EACE,uBAAuB;EACvB,YAAY;EACZ,aAAa;AACf;AACA;EACE,sBAAsB;AACxB;AACA;EACE,eAAe;AACjB;AACA;EACE,yBAAyB;EACzB,WAAW;AACb;AACA;EACE,UAAU;AACZ;AACA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,WAAW;EACb;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,cAAc;EAChB;AACF;AACA,wCAAwC;AACxC;;;EAGE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,4BAA4B;EAC5B,kBAAkB;AACpB;AACA;;EAEE,kBAAkB;EAClB,qBAAqB;EACrB,aAAa;AACf","sourcesContent":[".user_header {\n  padding: 5px 25px;\n  display: flex;\n  justify-content: space-between;\n  background: #ffffff 0% 0% no-repeat padding-box;\n  place-items: center;\n}\n.user_header .user_img {\n  display: flex;\n  place-items: center;\n}\n.user_header .user_imgs {\n  height: 69px;\n  width: 69px;\n  margin-right: 20px;\n}\n.user_img p {\n  margin: 0;\n}\n.user_header .user_imgs img {\n  width: 100%;\n  height: auto;\n}\n.selected_Button_bg {\n  background-color: #108757;\n  color: #fff;\n}\n.user_header button img,\nbutton.accueil img {\n  margin: 0 15px;\n}\n.user_header button,\nbutton.accueil {\n  display: flex;\n  place-items: center;\n  min-width: 129px;\n  border: 1px solid #108757;\n  color: #108757;\n  margin-left: 20px;\n  background: #1087571a 0% 0% no-repeat padding-box;\n  height: 37px;\n}\n.notifiaction_bar {\n  display: flex;\n}\n\n.addSaved .MuiPaper-root.MuiPaper-elevation {\n  color: #000000e6;\n  border: 1px solid #bcebdc;\n  background-color: #bcebdc;\n  font-size: 14px;\n  display: flex;\n  padding: 0 26px;\n  place-items: center;\n  height: 54px;\n  margin-left: auto;\n}\n.addSaved img {\n  margin-right: 5px;\n}\n.addSaved {\n  display: flex;\n  justify-content: space-between;\n  min-width: 250px;\n}\n.addSaved svg {\n  margin-left: 5px;\n  font-size: 14px;\n}\n.fremimg {\n  text-align: center;\n  margin: 0 auto;\n  padding: 30px 0 10px;\n}\n.ResumeTableSection {\n  max-width: 750px;\n  margin: 0 auto;\n}\n.fremimg img {\n  margin: 0 auto;\n}\n.fremimg h3 {\n  padding: 20px;\n  font-size: 24px;\n  color: #373737;\n}\n.information_form {\n  max-width: 600px;\n  margin: 0 auto !important;\n  border: 1px solid #ffbe00;\n  background-color: #ffbe001a;\n}\np {\n  font-size: 14px;\n  color: #373737;\n}\n.questionPage {\n  max-width: 750px;\n  margin: 20px auto 10px;\n}\n.notifiaction_status {\n  position: relative;\n  margin-right: 15px;\n}\n.notifiaction_status span {\n  position: absolute;\n  background-color: red;\n  border-radius: 50%;\n  top: -8px;\n  text-align: center;\n  right: -8px;\n  line-height: 21px;\n  width: 20px;\n  height: 21px;\n  font-size: 11px;\n  color: #fff;\n}\n.user_content {\n  text-align: center;\n  width: 230px;\n  height: 249px;\n}\n.user_content p {\n  position: relative;\n  padding: 16px 15px;\n  margin: 0 auto;\n  max-width: 196px;\n  color: #108757;\n}\n.user_content:hover {\n  background: #1087571a 0% 0% no-repeat padding-box;\n}\n.user_content {\n  cursor: pointer;\n  background: #fafafa 0% 0% no-repeat padding-box;\n}\n.user_content_img {\n  height: 150px;\n  padding: 20px;\n}\n.user_content img {\n  width: 100%;\n  height: auto;\n}\n.content_disponibles h4 {\n  padding-bottom: 20px;\n  color: #373737;\n  font-weight: bold;\n  font-size: 20px;\n  text-align: center;\n}\n\n.user_content p span {\n  position: absolute;\n  top: 15px;\n  right: 0;\n}\n.user_content p span svg {\n  font-size: 15px;\n}\n/* ********************* */\n.stepFormfields {\n  padding: 0 15px;\n  margin-top: 10px;\n}\n.butnaccueil {\n  flex-wrap: wrap;\n  display: flex;\n  place-items: center;\n}\n.butnaccueil .accueil svg {\n  fill: #108757;\n  margin-right: 10px;\n  margin-left: 10px;\n}\n.butnaccueil p {\n  font-size: 14px;\n  color: #373737;\n  font-weight: 600;\n  margin: 0 20px;\n}\n.addSaved .MuiPaper-root.MuiPaper-elevation {\n  color: #000000e6;\n  border: 1px solid #bcebdc;\n  background-color: #bcebdc;\n  font-size: 14px;\n  display: flex;\n  padding: 0 26px;\n  place-items: center;\n  height: 54px;\n  margin-left: auto;\n}\n.addSaved img {\n  margin-right: 5px;\n}\n.addSaved {\n  display: flex;\n  justify-content: space-between;\n  min-width: 250px;\n}\n.addSaved svg {\n  margin-left: 5px;\n  font-size: 14px;\n}\n.fremimg {\n  text-align: center;\n  margin: 0 auto;\n  padding: 30px 0 10px;\n}\n.ResumeTableSection {\n  max-width: 750px;\n  margin: 0 auto;\n}\n.fremimg img {\n  margin: 0 auto;\n}\n.fremimg h3 {\n  padding: 20px;\n  font-size: 24px;\n  color: #373737;\n}\n.information_form {\n  max-width: 600px;\n  margin: 0 auto !important;\n  border: 1px solid #ffbe00;\n  background-color: #ffbe001a;\n}\np {\n  font-size: 14px;\n  color: #373737;\n}\n.questionPage {\n  max-width: 750px;\n  margin: 20px auto 10px;\n}\n.questionPage Accordion svg {\n  display: none;\n}\n/* .MuiAccordionSummary-gutters [aria-expanded=\"true\"]{\n    background-color: red;\n} */\n.Mui-expanded.MuiAccordionSummary-gutters {\n  background: #108757 !important;\n  max-height: 50px !important;\n  min-height: 50px !important;\n}\n.questionPage .MuiAccordionSummary-gutters p {\n  position: relative;\n  font-weight: 600;\n  color: #373737;\n  padding-left: 35px;\n}\n.questionPage .MuiAccordionSummary-gutters svg {\n  display: none;\n}\n.Mui-expanded.MuiAccordionSummary-gutters p {\n  color: #fff !important;\n}\n.MuiAccordionSummary-gutters p span {\n  width: 100%;\n  display: block;\n  font-size: 10px !important;\n}\n.MuiPaper-elevation1.MuiAccordion-root {\n  margin: 10px 0;\n}\naccordion .MuiFormControl-root label.MuiFormLabel-root {\n  padding: 10px 0;\n}\n.user_header button img,\nbutton.accueil img {\n  margin: 0 15px;\n}\n.radiobtn_custom {\n  /* width: 15px !important; */\n  position: absolute;\n  left: 0;\n  top: 10px;\n  /* height: 15px; */\n  /* border-radius: 50%; */\n  /* border: 1px solid #eee; */\n  /* background: #fff; */\n}\n.questionPage\n  .Mui-expanded.MuiAccordionSummary-gutters\n  .radiobtn_custom\n  svg\n  #check {\n  fill: #108757;\n}\n.questionPage .Mui-expanded.MuiAccordionSummary-gutters .radiobtn_custom svg g {\n  fill: #fff !important;\n}\n.questionPage .radiobtn_custom svg {\n  display: block;\n}\n.questionPage button {\n  border: 1px solid #108757;\n  color: #108757;\n  /* height: 60px; */\n  padding: 12px 30px;\n}\n/* ****************** */\n.cahiersheet-optionsheet .enteres-option {\n  margin-bottom: 30px;\n  color: #373737;\n  font-size: 16px;\n  font-weight: 600;\n}\n.transection-option .form-label {\n  color: #373737;\n  font-size: 16px;\n  padding: 20px 24px;\n  border-bottom: 1px solid #ddd;\n}\n.transection-option .MuiGrid-root {\n  position: relative;\n}\n\n.transection-option .ant-space.ant-space-vertical {\n  position: relative;\n}\n.transection-option {\n  border: 1px solid #ddd !important;\n  border-radius: 5px;\n  width: 100%;\n  margin-bottom: 30px !important;\n}\n.transection-option .MuiFormGroup-root {\n  padding: 0 40px;\n}\n/* .questionPage .MuiTextField-root .Mui-error.MuiInputBase-formControl:hover{\n border: 1px solid red;\n} */\n.questionPage\n  .Mui-error.MuiInputBase-formControl:hover\n  .MuiOutlinedInput-notchedOutline {\n  border-color: #d32f2f;\n}\n/* .MuiInputBase-colorPrimary.Mui-error.MuiInputBase-formControl:hover .MuiOutlinedInput-notchedOutline{\n  border-color: #d32f2f;\n} */\n/* ***************** */\n.btntag {\n  border: 1px solid #108757;\n  width: 130px;\n  height: 37px;\n  color: #108757;\n  display: flex !important;\n  place-items: center;\n  padding: 1px 15px;\n}\n.btntag svg {\n  fill: #ededed !important;\n}\n.resumeTabels th {\n  height: 130px;\n  background-color: #ededed;\n  width: 220px;\n  max-width: 220px;\n  border: 1px solid #fafafa !important;\n}\n.resumeTabels th,\n.resumeTabels td {\n  border: 1px solid #ededed;\n  text-transform: capitalize;\n  padding: 0 15px;\n  min-width: 200px;\n  text-align: left;\n  color: #373737;\n  font-weight: 600;\n}\n.submitButton {\n  color: #fff !important;\n  background: #238957;\n  border: none;\n}\n.firstcreatCreer {\n  margin-top: 30px;\n  border: 1px solid #ededed;\n}\n.optionforans {\n  padding: 33px 40px 31px !important;\n}\n.datepicbyyear {\n  place-items: center;\n  cursor: pointer;\n  justify-content: center;\n  display: flex;\n  border: 1px solid #108757;\n  width: 200px;\n  height: 30px;\n  margin-left: 90px;\n}\n.claenderweekss h2 svg {\n  font-size: 14px;\n}\n.claenderweekss h2 {\n  padding: 5px 10px;\n}\n.creatbtn-redirect {\n  margin-left: auto;\n}\n.feremtabn .creatbtn-redirect button {\n  max-height: 50px !important;\n}\n\n.stepform-fiche {\n  height: 100% !important;\n}\n.datepicbyyear input {\n  outline: none;\n}\n.conditionshowCreat {\n  width: 536%;\n  text-align: center;\n}\n.feremtabn {\n  display: flex;\n  flex-wrap: wrap;\n}\n.feremtabn .Mui-selected {\n  background: #108757;\n  min-height: 25px !important;\n  max-height: 30px !important;\n  color: #ffff !important;\n}\n.nav.nav-pills.pull-right .tabbtn {\n  display: flex;\n  min-width: 140px;\n  padding: 0 10px;\n  height: 30px !important;\n  justify-content: center;\n  place-items: center;\n}\n.nav.nav-pills.pull-right {\n  display: flex;\n  margin-bottom: 0;\n  margin-left: 20px;\n}\n.feremtabn .nav.nav-pills.pull-right .tabbtn {\n  margin: 2px 10px;\n  text-transform: capitalize;\n  min-height: 37px !important;\n}\n\n.nav.nav-pills.pull-right .tabbtn,\n.feremtabn button {\n  color: #108757;\n  min-height: 25px !important;\n  max-height: 30px !important;\n  border: 1px solid #108757;\n}\n.feremtabn span.MuiTabs-indicator.css-54v6xy-MuiTabs-indicator,\n.datepicbyyear fieldset {\n  display: none;\n}\n.conditionshowCreat p {\n  font-size: 16px;\n  padding-top: 5px;\n}\n.datepicbyyear .MuiSelect-select {\n  padding-right: 0 !important;\n}\n.datepicbyyear .MuiOutlinedInput-root {\n  height: 28px;\n  border: none;\n}\n.datepicbyyear .MuiOutlinedInput-root:hover {\n  border: none;\n}\n.datepicbyyear .MuiOutlinedInput-root svg {\n  display: none;\n}\n.datepicbyyear label {\n  line-height: 1;\n  top: -9px;\n}\n.datepicbyyear .css-1xyznfm-MuiFormLabel-root-MuiInputLabel-root {\n  display: none;\n}\n.whiteColor {\n  color: #fff;\n}\n\n.questionPage h2 {\n  padding-bottom: 20px;\n  padding-left: 40px;\n}\n.questionPage h1 {\n  margin-top: 40px;\n  font-size: 34px;\n  color: #979797;\n  font-weight: 600;\n  text-align: center;\n}\n.weektextday p {\n  margin: 0;\n}\n.weektextday {\n  position: relative;\n  color: #979797;\n  font-size: 14px;\n  text-align: center;\n  border: 1px solid #108757;\n  width: 102px;\n  height: 79px;\n  vertical-align: middle;\n  display: table-cell;\n  /* margin: 0 auto; */\n}\n.calenderWeek {\n  padding: 15px 45px;\n  border: 1px solid #ededed;\n  margin-bottom: 20px;\n}\n.questionPage label#demo-radio-buttons-group-label {\n  padding: 15px 0 !important;\n}\n.ant-steps-item-finish .ant-steps-item-icon {\n  background-color: #108757 !important;\n  /* top:-3.5px !important; */\n}\n.ant-steps-item-finish .ant-steps-icon {\n  top: -3.5px !important;\n}\n.ant-steps-item-finish .ant-steps-item-icon svg {\n  fill: #fff;\n}\n/* MuiButtonBase-root MuiRadio-root MuiRadio-colorPrimary PrivateSwitchBase-root MuiRadio-root MuiRadio-colorPrimary MuiRadio-root MuiRadio-colorPrimary css-v39bad */\n.claenderweekss .weektextday .MuiFormControlLabel-root .MuiRadio-root {\n  left: 0 !important;\n  position: absolute !important;\n  width: 100%;\n  height: 100%;\n  /* opacity: 0; */\n  top: 0;\n}\n/* .css-1uef0s5-MuiButtonBase-root-MuiRadio-root.Mui-checked .weektextday .css-1uef0s5-MuiButtonBase-root-MuiRadio-root:after{\n    width: 100%;\n    left: 0 !important;\n    position: absolute !important;\n    width: 100%;\n    height: 100%;\n    content: \"\";\n    border: 10px solid red;\n    top: 0;\n\n} */\n.claenderweekss\n  span.MuiButtonBase-root.MuiRadio-root.MuiRadio-colorPrimary.PrivateSwitchBase-root.MuiRadio-root.MuiRadio-colorPrimary.Mui-checked:after {\n  width: 100%;\n  left: 0;\n  position: absolute !important;\n  width: 100%;\n  z-index: -1;\n  height: 100%;\n  background-color: #108757;\n  content: \"\";\n  border: 5px solid #108757;\n  top: 0;\n  opacity: 1;\n}\n.claenderweekss\n  span.MuiButtonBase-root.MuiRadio-root.MuiRadio-colorPrimary.PrivateSwitchBase-root.MuiRadio-root.MuiRadio-colorPrimary.Mui-checked.MuiRadio-root.MuiRadio-colorPrimary.css-1uef0s5-MuiButtonBase-root-MuiRadio-root\n  ~ p {\n  color: #fff !important;\n}\n.claenderweekss label {\n  margin-left: 16px !important;\n  height: 100%;\n}\n.questionPage .MuiPaper-elevation {\n  box-shadow: none;\n  border: 1px solid #cacaca;\n}\n.weektextday .css-hyxlzm {\n  opacity: 0;\n}\n/* ::::::::::::::::Radio:::::::: */\n.cahiersheet-optionsheet .MuiFormControl-root.MuiTextField-root {\n  max-width: 800px;\n  width: 100%;\n  margin-bottom: 30px;\n}\n.cahiersheet-optionsheet span {\n  font-size: 16px;\n  color: rgb(55, 55, 55);\n  font-weight: 600;\n  /* color: #373737; */\n}\n.cahiersheet-optionsheet .ant-input-number-group-wrapper,\n.cahiersheet-optionsheet .ant-space.ant-space-vertical {\n  max-width: 800px;\n  width: 100%;\n  /* margin-bottom: 15px; */\n}\n\n.cahiersheet-optionsheet .ant-input-number-group-wrapper {\n  border: 1px solid #cacaca;\n}\n.cahiersheet-optionsheet\n  .MuiInputBase-formControl:hover\n  .MuiOutlinedInput-notchedOutline {\n  border-color: #238957;\n}\n\n.cahiersheet-optionsheet .ant-input-number-group-wrapper input {\n  height: 55px;\n}\n.questionPage .transection-option .cahier-label {\n  font-size: 16px;\n  color: #373737;\n  font-weight: 600;\n  letter-spacing: 0.26px;\n  opacity: 1;\n  padding: 20px 0px;\n}\n.cahiersheet-optionsheet .outlined-basic {\n  font: 16px;\n  letter-spacing: 0.26px;\n  color: #979797;\n  opacity: 1;\n}\n/* .cahiersheet-optionsheet .ant-space-item .ant-select  span.ant-select-arrow{\n    display: none !important;\n} */\n.cahiersheet-optionsheet .ant-space-item .MuiInputBase-formControl {\n  padding: 0 !important;\n}\n.cahiersheet-optionsheet .MuiInputBase-colorPrimary.MuiInputBase-formControl {\n  height: 65px;\n}\n\n/* :::::::::::::::::::::::step:::::::::::::: */\n.MuiStepLabel-vertical {\n  cursor: pointer !important;\n}\n\n.questionPage.transection-option .MuiFormGroup-root {\n  padding-top: 10px !important;\n}\n.claenderweekss .react-datepicker__day-names,\n.claenderweekss .react-datepicker__month {\n  display: none;\n}\n.claenderweekss .react-datepicker {\n  border: none;\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  padding-bottom: 30px !important;\n  padding: 0 65px;\n  background: #fafafa;\n}\n.claenderweekss .react-datepicker__navigation {\n  border: none;\n  outline: none;\n}\n.claenderweekss .react-datepicker__header {\n  background: #fafafa;\n  /* border: none; */\n}\n.claenderweekss\n  span.react-datepicker__navigation-icon.react-datepicker__navigation-icon--previous {\n  border-color: #373737;\n  border-style: solid;\n  border-width: 3px 3px 0 0;\n  content: \"\";\n  display: block;\n  height: 9px;\n  position: absolute;\n  top: 6px;\n  width: 9px;\n  transform: rotate(225deg);\n  right: -7px;\n  left: 2px;\n}\n/* .claenderweekss .react-datepicker__navigation-icon--previous:before {\n    transform: rotate(225deg);\n    right: -7px;\n} */\n\n.claenderweekss\n  span.react-datepicker__navigation-icon.react-datepicker__navigation-icon--next {\n  transform: rotate(45deg);\n  border-color: #373737;\n  right: 5;\n  border-style: solid;\n  border-width: 3px 3px 0 0;\n  content: \"\";\n  display: block;\n  height: 9px;\n  position: absolute;\n  top: 6px;\n  width: 9px;\n}\n.seconddatetabel .MuiFormControl-root.css-1nrlq1o-MuiFormControl-root {\n  max-width: 223px;\n  margin-left: auto;\n  display: flex;\n}\n.Appbatabbtn .feremtabn .MuiTab-textColorPrimary.Mui-selected {\n  background-color: #108757;\n  color: #fff;\n  fill: #fff;\n}\n.Appbatabbtn button {\n  max-height: 43px !important;\n}\n.Appbatabbtn .feremtabn .MuiTab-textColorPrimary.Mui-selected svg {\n  fill: #fff;\n}\n.Appbatabbtn .feremtabn svg {\n  fill: #108757;\n  margin-right: 10px;\n}\n.claenderweekss .react-datepicker__year-read-view {\n  opacity: 0;\n  visibility: visible;\n}\n.claenderweekss .react-datepicker__year-dropdown {\n  min-width: 92px;\n}\n.claenderweekss\n  .react-datepicker__header__dropdown.react-datepicker__header__dropdown--scroll {\n  position: absolute;\n  top: 8px;\n  width: 100%;\n  z-index: 9;\n}\n.claenderweekss\n  .react-datepicker__year-dropdown-container.react-datepicker__year-dropdown-container--scroll {\n  width: 100%;\n}\n.claenderweekss .react-datepicker__header {\n  position: relative;\n}\n/* .customyeardropdown button{\n    border: 0.45rem solid transparent;\n    z-index: 1;\n    top:5px;\n    height: 10px;\n    width: 10px;\n} */\n.customyeardropdown\n  .react-datepicker__navigation.react-datepicker__navigation--previous,\n.customyeardropdown\n  .react-datepicker__navigation.react-datepicker__navigation--next {\n  transform: rotate(45deg);\n  border-color: #373737;\n  right: 5;\n  border-style: solid;\n  border-width: 3px 3px 0 0;\n  content: \"\";\n  display: block;\n  min-height: 9px !important;\n  position: absolute;\n  top: 12px;\n  width: 9px;\n}\n.customyeardropdown\n  .react-datepicker__navigation.react-datepicker__navigation--previous {\n  transform: rotate(225deg);\n}\n.datepicbyyear input[type=\"text\"] {\n  max-width: 150px;\n  cursor: pointer;\n}\n\n.accordionRadio {\n  display: flex !important;\n  flex-direction: column !important;\n}\n.ResumeTableSection td {\n  color: #373737;\n  font-size: 16px;\n  font-weight: 600;\n}\n.ResumeTableSection td h1 {\n  color: #373737;\n  padding-top: 20px;\n  padding-bottom: 15px;\n  font-size: 16px;\n}\n.resumeTabels td h4,\n.ResumeTableSection td h4 {\n  color: #979797;\n  margin: 0;\n  font-size: 14px;\n}\n.resumeTabels td p,\n.ResumeTableSection td p {\n  color: #373737;\n  font-size: 14px;\n}\n.resumeTabels .tabel-edit-section {\n  display: flex;\n  place-items: center;\n  height: 130px;\n  justify-content: space-between;\n}\n.resumeTabels .editIcon-on-tabel svg {\n  margin: 0 auto;\n}\n.resumeTabels .editIcon-on-tabel svg,\n.resumeTabels .editIcon-on-tabel {\n  color: #cacaca;\n  cursor: pointer;\n  fill: #cacaca;\n}\n.resumeTabels .editIcon-on-tabel:hover svg {\n  fill: #108757;\n}\n.resumeTabels .editIcon-on-tabel:hover {\n  color: #108757;\n}\n.cfa-text p {\n  position: inherit !important;\n}\n.cfa-text {\n  position: absolute;\n  top: 0;\n  right: 2px;\n  height: 64px;\n  z-index: -1;\n}\n.questionPage .ant-space-item input.MuiInputBase-input {\n  padding-right: 70px;\n}\n/* ******************** repoprt css***************** */\n\n.stockReportSection {\n  /* min-width: 1200px; */\n  max-width: 1200px;\n  width: 100%;\n  margin: 0px auto 10px;\n}\n.stockReportSection .card {\n  padding: 15px 25px 15px 15px;\n  margin: 0px 0 20px;\n}\n\n.stockReportSection .items-dtails h4 {\n  font-size: 20px;\n  color: #979797 !important;\n  font-weight: normal !important;\n}\n.items-dtails:nth-child(1) {\n  border-bottom: 1px solid #ededed;\n  width: 80%;\n}\n.report-img h2 {\n  font-size: 20px;\n}\n.stockReportSection .items-dtails p {\n  font-size: 14px;\n  max-width: 216px;\n  margin-top: 10px;\n  margin-left: 10px;\n}\n.items-dtails-quantity {\n  min-width: 200px;\n}\n.stockReportSection .items-dtails h3 {\n  font-size: 30px;\n  color: #373737 !important;\n  margin-bottom: 0;\n  font-weight: normal !important;\n}\n.stockReportSection .items-dtails {\n  padding: 10px 0px;\n}\np,\nh1,\nh3,\nh4,\nh5,\nh6 {\n  color: #373737;\n}\n.stockReportSection .report-img svg {\n  margin: 0 auto;\n}\n.stockReportSection .report-img {\n  text-align: center;\n}\n.stockReportSection .MuiGrid-container {\n  place-items: center;\n}\n.button-on-report {\n  color: #108757;\n  border: 1px solid #108757;\n  width: 243px;\n  width: 100%;\n  height: 60px;\n}\n.items-dtails {\n  display: flex;\n}\n.feremtabn .MuiTabs-scroller .MuiTabs-flexContainer {\n  max-width: 472px;\n  overflow: auto;\n  padding-bottom: 3px;\n}\n::-webkit-scrollbar {\n  width: 5px;\n  height: 5px;\n  background: #ddd !important;\n}\n\n::-webkit-scrollbar-thumb {\n  background: #108757 !important;\n}\n\n/* ************************report details css****************** */\n/* .ant-tabs-tab.ant-tabs-tab-active{\n    \n} */\n.ant-tabs-tab.ant-tabs-tab-active {\n  background-color: #108757 !important;\n  color: #fff;\n}\n.ant-tabs-tab svg {\n  margin: 0 auto;\n}\n.ant-tabs-tab {\n  justify-content: center;\n  width: 213px;\n  height: 152px;\n}\n.ant-tabs-tab.ant-tabs-tab-active h1 {\n  color: #fff !important;\n}\n.stockReportSection h4.pt-4 {\n  font-size: 18px;\n}\n.nav.nav-pills.pull-right .active {\n  background-color: #108757;\n  color: #fff;\n}\n.nav.nav-pills.pull-right .active svg {\n  fill: #fff;\n}\n@media screen and (max-width: 467px) {\n  .claenderweekss .react-datepicker {\n    padding: 0 30px;\n  }\n}\n\n@media screen and (max-width: 767px) {\n  .information_form {\n    max-width: 520px;\n  }\n\n  .weektextday {\n    width: 90px;\n  }\n  .claenderweekss label {\n    margin-left: 8px !important;\n  }\n}\n\n@media screen and (max-width: 990px) {\n  .user_header .user_img {\n    display: initial;\n  }\n  .nav.nav-pills.pull-right {\n    margin-top: 15px;\n  }\n  .datepicbyyear {\n    margin-left: 10px;\n  }\n  .creatbtn-redirect {\n    margin: 0 auto;\n  }\n}\n/* ************ velidation *********** */\n.errorText,\np.Mui-error,\n.MuiFormHelperText-root {\n  color: red !important;\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.cahiersheet-optionsheet .MuiBox-root .transection-option,\n.cahiersheet-optionsheet .MuiFormControl-fullWidth.transection-option {\n  border: 0px solid !important;\n  position: relative;\n}\n.transection-option .MuiBox-root p,\n.transection-option .ant-space.ant-space-vertical p {\n  position: absolute;\n  color: red !important;\n  bottom: -22px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
